import React, { Component, Fragment } from "react";
import "./Footer.scss"

const Footer = ({bg}) => {

  const clickedLink = (link) => {
    window.open(link, "_blank");
    window.dataLayer.push({ event: "Outbound_Events", Category: "Outbound", "Action": link });
  }


  return (
    <footer className={`footer ${bg == "true" ? "bg" : ""}`} id="footer">
      {window.isMobile() &&
        <div className="prev-projects">
          <div onClick={() => clickedLink("https://z.ynet.co.il/short/content/2019/LastCall/")} target="_blank">קריאה אחרונה 2019</div>
            |
            <div onClick={() => clickedLink("https://z.ynet.co.il/short/content/2018/LastCall/")} target="_blank">קריאה אחרונה 2018</div>
        </div>
      }
      <div className="links-wrapper">
        {!window.isMobile() &&
          <Fragment>
            <div onClick={() => clickedLink("https://z.ynet.co.il/short/content/2019/LastCall/")} target="_blank">קריאה אחרונה 2019</div>
              |
              <div onClick={() => clickedLink("https://z.ynet.co.il/short/content/2018/LastCall/")} target="_blank">קריאה אחרונה 2018</div>
              |
            </Fragment>
        }
        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank">
          תנאי שימוש
          </a>
          |
          <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank">
          מדיניות פרטיות
          </a>
          |
          <a href="https://yit.co.il/" target="_blank">
          אפיון, עיצוב, ופיתוח
            <span className="yit-logo"></span>
        </a>
      </div>

    </footer>
  );

}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx